import { render, staticRenderFns } from "./gasClamp_wincc.vue?vue&type=template&id=6221fc58&scoped=true"
import script from "./gasClamp_wincc.vue?vue&type=script&lang=js"
export * from "./gasClamp_wincc.vue?vue&type=script&lang=js"
import style0 from "./gasClamp_wincc.vue?vue&type=style&index=0&id=6221fc58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6221fc58",
  null
  
)

export default component.exports